import { functionUrls } from '../../../services/firebaseFunctions';
import { loginMachine } from '../../../auth/loginMachine';
import type { LocalFoodItem } from '../types/detailsCard.types';

export async function streamRegionalDishes(params: {
  locationName: string;
  userLanguageLabel: string;
  viewportWikiLanguage: string;
  onItem: (item: LocalFoodItem) => void;
}): Promise<LocalFoodItem[]> {
  const { locationName, userLanguageLabel, viewportWikiLanguage, onItem } = params;

  loginMachine.recordUsage('llm');

  const idToken = await loginMachine.getIdToken();
  if (!idToken) {
    const err: any = new Error('AUTH_REQUIRED');
    err.code = 'AUTH_REQUIRED';
    throw err;
  }
  const query = new URLSearchParams({
    location: locationName,
    userLangLabel: userLanguageLabel,
    wikiLang: viewportWikiLanguage,
    authToken: idToken,
  });

  const url = `${functionUrls.streamRegionalDishes}?${query.toString()}`;

  return new Promise<LocalFoodItem[]>((resolve, reject) => {
    const items: LocalFoodItem[] = [];
    const es = new EventSource(url);

    es.onmessage = (event) => {
      const raw = String(event.data || '').trim();
      if (!raw) return;

      if (raw === '[DONE]') {
        es.close();
        resolve(items);
        return;
      }

      try {
        const parsed = JSON.parse(raw);
        const item: LocalFoodItem = {
          title: String(parsed?.title || '').trim(),
          imagelink: String(parsed?.imagelink || '').trim(),
          description: String(parsed?.description || '').trim(),
        };

        if (!item.title) return;
        items.push(item);
        onItem(item);
      } catch (err) {
        console.error('[LocalFood] Failed to parse stream item', err, event.data);
      }
    };

    es.onerror = () => {
      es.close();
      reject(new Error('STREAM_ERROR'));
    };
  });
}
